import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import RouteName from "../../../routes/Route.name";
import history from "../../../libs/history.utils";
import LogUtils from "../../../libs/LogUtils";
import {
  actionFetchUserQueries,
  actionSetPageUserQueries,
} from "../../../actions/UserQueries.action";
import { serviceGetList } from "../../../services/index.services";
import { serviceGetConcernList } from "../../../services/UserQueries.service";

const useUserQueriesListHook = ({}) => {
  const [listData, setListData] = useState({
    CONCERNS: [],
  });
  const dispatch = useDispatch();
  const isMountRef = useRef(false);

  const {
    sorting_data: sortingData,
    is_fetching: isFetching,
    query,
    query_data: queryData,
    all,
  } = useSelector((state) => state?.user_queries);

  useEffect(() => {
    serviceGetConcernList().then((res) => {
      if (!res.error) {
        setListData((prevListData) => ({
          ...prevListData,
          CONCERNS: res.data,
        }));
      }
    });
  }, []);


  useEffect(() => {
    dispatch(
      actionFetchUserQueries(
        1,
        {},
        {
          query: isMountRef.current ? query : null,
          query_data: isMountRef.current ? queryData : null,
        }
      )
    );
    isMountRef.current = true;
  }, []);

 
  const handlePageChange = useCallback((type) => {
    dispatch(actionSetPageUserQueries(type));
  }, []);

  const queryFilter = useCallback(
    (key, value) => {
      dispatch(
        actionFetchUserQueries(1, sortingData, {
          query: key == "SEARCH_TEXT" ? value : query,
          query_data: key == "FILTER_DATA" ? value : queryData,
        })
      );
    },
    [sortingData, query, queryData]
  );

  const handleFilterDataChange = useCallback(
    (value) => {
      const filteredValue = value?.map((item) => {
       
        if (item?.name === "concern") {
          const matched = listData?.CONCERNS?.find(
            (concern) => concern?.label === item?.value
          );
          return { ...item, value: matched?.value || item?.value };
        }
  
        return item;
      });
      queryFilter("FILTER_DATA", filteredValue);
    },
    [queryFilter]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      queryFilter("SEARCH_TEXT", value);
    },
    [queryFilter]
  );

  const handleSortOrderChange = useCallback(
    (row, order) => {
      dispatch(actionSetPageUserQueries(1));
      dispatch(
        actionFetchUserQueries(
          1,
          { row, order },
          {
            query: query,
            query_data: queryData,
          }
        )
      );
    },
    [query, queryData]
  );
 
  const handleDetail = useCallback((type) => {
    history.push(`${RouteName.USER_QUERIES_DETAIL}${type?.id}`);
  }, []);

  const configFilter = useMemo(() => {
    return [
      {
        label: "Status",
        name: "status",
        type: "select",
        fields: ["PENDING", "RESOLVED", "IN_PROGRESS", "DISPOSED"],
      },
      {
        label: "Concern",
        name: "concern",
        type: "select",
        fields: listData?.CONCERNS?.map((val)=>val?.label),
      },
    ];
  }, [listData]);

 
  return {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleSortOrderChange,
    configFilter,
    handleDetail,
  };
};

export default useUserQueriesListHook;
